import React, { useState } from "react";
import { any, func, bool, string } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import {
  postCarltonForestForm,
  submitCarltonForestForm,
} from "../../redux/actions";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  useForm,
  getField,
} from "../../common/FormCreator/helpers";

const CarltonForestInductionChecklist = ({
  appData,
  postCarltonForestFormFunc,
  submitCarltonForestFormFunc,
}) => {
  let initialData = {
    Agency: "HRGO Recruitment",
    Inductee: `${appData.firstName} ${appData.lastName}`,
    Initials: `${appData.firstName} ${appData.lastName}`,
    InductionDate: moment().format("DD/MM/YYYY"),
  };

  if (
    appData.carltonForestOnboarding &&
    appData.carltonForestOnboarding.inductionForm
  ) {
    initialData = {
      ...initialData,
      ...appData.carltonForestOnboarding.inductionForm,
    };
  }
  const submitted =
    appData.carltonForestOnboarding &&
    appData.carltonForestOnboarding.submitted;

  const getVal = getField(initialData);

  const initialState = {
    Agency: {
      type: "text",
      title: "Agency Name",
      value: getVal("Agency"),
      disabled: true,
    },
    Inductee: {
      type: "text",
      title: "Agency Inductee Print Name",
      value: getVal("Inductee"),
      disabled: true,
    },
    Initials: {
      type: "text",
      title: "Sign Name",
      value: getVal("Initials"),
      disabled: true,
    },
    InductionDate: {
      type: "text",
      title: "Date",
      value: getVal("InductionDate"),
      disabled: true,
    },
    Checklist1: {
      key: "Checklist1",
      title:
        "Emergency Fire and Evacuation awareness on site – Emergency Exits/Fire Extinguishers/Fire call Point & Assembly Point",
      value: getVal("Checklist1"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist2: {
      key: "Checklist2",
      title: "Read and understood SSOW's *relevant to job specification",
      value: getVal("Checklist2"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist3: {
      key: "Checklist3",
      title: "First Aid and Near Miss Procedure",
      value: getVal("Checklist3"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist4: {
      key: "Checklist4",
      title:
        "Site Rules (pedestrian routes/signage/mobile phone restrictions) *discussed also on-site tour",
      value: getVal("Checklist4"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist5: {
      key: "Checklist5",
      title:
        "Welfare facilities – Rest rooms/Smoking areas/canteen or kitchen areas *discussed and shown on-site tour",
      value: getVal("Checklist5"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist6: {
      key: "Checklist6",
      title:
        "CFG.com Policies – Smoking, Hygiene, Drugs & Alcohol *completed on day one",
      value: getVal("Checklist6"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist7: {
      key: "Checklist7",
      title: "Manual Handling Awareness/ Power Point Understood",
      value: getVal("Checklist7"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist8: {
      key: "Checklist8",
      title: "Copy of any Truck Licence (if applicable)",
      value: getVal("Checklist8"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    Checklist9: {
      key: "Checklist9",
      title: "Personal Protective Equipment – correct PPE worn to start shift",
      value: getVal("Checklist9"),
      type: "checkbox",
      checkboxText1: "Done",
      checkboxText2: "N/A",
      mandatory: true,
    },
    ConsentCheck: {
      key: "ConsentCheck",
      title:
        "I hereby acknowledge that I understand and will adhere to the Information, Training & Instruction that has been provided.  Signed & dated above",
      value: getVal("ConsentCheck"),
      type: "singlecheckbox",
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    postCarltonForestFormFunc(
      "inductionForm",
      {
        ...fieldValuesPayload,
      },
      "YCFG"
    );

    history.push("/profile/edit/carlton-forest-onboarding");
  };

  const submitForm = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitCarltonForestFormFunc("inductionForm", {
      ...fieldValuesPayload,
    });

    history.push("/profile/edit/carlton-forest-onboarding");
  };
  return (
    <>
      {submitted ? (
        history.push("/profile/edit/carlton-forest-onboarding")
      ) : (
        <FormCreatorV2
          formTitle={"CFG 3PL Agency Staff Induction"}
          helper={""}
          fields={fields}
          setField={setField}
          handleSubmit={handleSubmit}
          handleCancel={() =>
            history.push("/profile/edit/carlton-forest-onboarding")
          }
          onboardingBranch={"carltonForest"}
          submitSingleForm={true}
          handleSingleSubmit={submitForm} // Submits to PDF YCFG
        />
      )}
    </>
  );
};

CarltonForestInductionChecklist.propTypes = {
  appData: any,
  postCarltonForestFormFunc: func.isRequired,
  submitCarltonForestFormFunc: func.isRequired,
};

const mapDispatchToProps = {
  postCarltonForestFormFunc: postCarltonForestForm,
  submitCarltonForestFormFunc: submitCarltonForestForm,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(CarltonForestInductionChecklist);
